namespace('compass.tiles');

compass.tiles.NoValidHousingTileWidget = compass.defineWidget(function NoValidHousingWidget(options) {
	var me = this;
	var $j = jQuery;
	var _settings = options;

	this.render = function(widgetElem) {
		widgetElem.append(d.div({ className : 'tileWrapper tile' },
			d.div({ className : 'contentWrapper'},
				d.div({ className : 'message' },
					'Oh, hi. It looks like you',
					d.br(),
					'need a place to stay,',
					d.br(),
					d.span({ className : 'mainMessage' }, 'book with us!')
				),
				d.button({ className : 'shopHotels button' }, 'Shop Hotels').activate(_handleLink)
			)
		));
	};

	function _handleLink(e) {
		me.trigger(CompassEvents.Navigate, 'hotels');
	}

	var d = $j.dom.getContext(this);
}, {
	GUID : 'defaultNoValidHousingTileWidgetGUID',
	widgetName : 'NoValidHousingTileWidget'
});

